// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalResetPassByEmail__TTvv9 {
  height: 464px;
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalHeadSeparator__OiW0d {
  width: 100%;
  height: 1px;
  background-color: var(--header-stroke);
  position: relative;
}

.modalHeadSeparatorMark__kPxPN {
  width: 42px;
  height: 3px;
  background-color: var(--labels-filled-surface-standard);
  position: absolute;
  top: -1.5px;
  left: 0;
  z-index: 2;
}

.modalBody__JLDfS {
  height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 25px 25px 0;
}

.modalBodyTitle__zyZC8 {
  text-align: center;
  margin-bottom: 20px;
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.modalBodyDescription__6cMUb {
  font-size: 16px;
  line-height: 21px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
}

.modalBodyEmailInfo__mDD5q {
  width: 100%;
}

.userInfo__XhWtN {
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  color: var(--tables-primary-row-text-main);
  width: 100%;
  margin-top: 20px;
  padding: 10px 15px;
  border: 1px solid var(--inputs-filled-stroke);
  border-radius: 5px;
}
.userInfo__XhWtN p {
  font-size: 12px;
  line-height: 18px;
  text-transform: none;
  color: var(--tables-primary-row-text-additional);
  margin-top: 10px;
  margin-bottom: 0;
}

.modalFooter__xItWH {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  padding: 25px 46px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/ResetPasswordModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,WAAA;EACA,sCAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,WAAA;EACA,uDAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,mBAAA;EA3CA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA7BF;;AAwEA;EACE,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,kBAAA;AArEF;;AAwEA;EACE,WAAA;AArEF;;AAwEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,kBAAA;AArEF;AAuEE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;EACA,gBAAA;EACA,gBAAA;AArEJ;;AAyEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modalResetPassByEmail {\n  height: 464px;\n  width: 372px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalHeadSeparator {\n  width: 100%;\n  height: 1px;\n  background-color: var(--header-stroke);\n  position: relative;\n}\n\n.modalHeadSeparatorMark {\n  width: 42px;\n  height: 3px;\n  background-color: var(--labels-filled-surface-standard);\n  position: absolute;\n  top: -1.5px;\n  left: 0;\n  z-index: 2;\n}\n\n.modalBody {\n  height: 100%;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  padding: 25px 25px 0;\n}\n\n.modalBodyTitle {\n  text-align: center;\n  margin-bottom: 20px;\n\n  @include modalTitle;\n}\n\n.modalBodyDescription {\n  font-size: 16px;\n  line-height: 21px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n}\n\n.modalBodyEmailInfo {\n  width: 100%;\n}\n\n.userInfo {\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  text-align: center;\n  color: var(--tables-primary-row-text-main);\n  width: 100%;\n  margin-top: 20px;\n  padding: 10px 15px;\n  border: 1px solid var(--inputs-filled-stroke);\n  border-radius: 5px;\n\n  p {\n    font-size: 12px;\n    line-height: 18px;\n    text-transform: none;\n    color: var(--tables-primary-row-text-additional);\n    margin-top: 10px;\n    margin-bottom: 0;\n  }\n}\n\n.modalFooter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 30px;\n  padding: 25px 46px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalResetPassByEmail": `modalResetPassByEmail__TTvv9`,
	"modalHeadSeparator": `modalHeadSeparator__OiW0d`,
	"modalHeadSeparatorMark": `modalHeadSeparatorMark__kPxPN`,
	"modalBody": `modalBody__JLDfS`,
	"modalBodyTitle": `modalBodyTitle__zyZC8`,
	"modalBodyDescription": `modalBodyDescription__6cMUb`,
	"modalBodyEmailInfo": `modalBodyEmailInfo__mDD5q`,
	"userInfo": `userInfo__XhWtN`,
	"modalFooter": `modalFooter__xItWH`
};
module.exports = ___CSS_LOADER_EXPORT___;
